import React, { ChangeEvent } from 'react'
import SearchIcon from '@mui/icons-material/Search'
import ClearIcon from '@mui/icons-material/Clear'
import {
  TextField, IconButton, styled
} from '@mui/material'
import { escapeRegExp } from '../../utils/escapeRegExp'
interface Props<T> {
  searchData: T[]
  onSearch: (filteredData: T[] | undefined) => void
  placeholder: string
}

const StyledTextField = styled(TextField)({
  '& [data-testid=SearchIcon]': {
    margin: '0.5rem'
  }
})

const CustomSearch = <T extends Object>(props: Props<T>) => {
  const [value, setValue] = React.useState('')

  const handleSearch = (
    e:
    | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    | { target: { value: string } }
  ) => {
    setValue(e.target.value)
    if (!e.target.value) return props.onSearch(undefined)
    const searchRegExp = new RegExp(escapeRegExp(e.target.value), 'i')
    const filteredData = props.searchData.filter((searchValue) =>
      Object.values(searchValue).some((value) => {
        if (Array.isArray(value)) {
          return value.some((arrayValue) => searchRegExp.test(arrayValue))
        }
        if (typeof value === 'string') {
          return searchRegExp.test(value)
        }
        return false
      })
    )
    props.onSearch(filteredData)
  }

  return (
    <StyledTextField
      variant='outlined'
      placeholder={props.placeholder}
      onChange={handleSearch}
      value={value}
      InputProps={{
        startAdornment: <SearchIcon fontSize='small' />,
        endAdornment: (
          <IconButton
            title='Clear'
            aria-label='Clear'
            size='small'
            onClick={() => handleSearch({
              target: {
                value: ''
              }
            })}
          >
            <ClearIcon fontSize='small' />
          </IconButton>
        )
      }}
    />
  )
}
export default CustomSearch
